var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.439 6.164v1.934a1.22 1.22 0 1 1-2.439 0V3.22C2 2.546 2.546 2 3.22 2h4.878a1.22 1.22 0 1 1 0 2.439H6.164L8.96 7.235A1.22 1.22 0 1 1 7.235 8.96zm11.463-1.725a1.22 1.22 0 0 1 0-2.439h4.879C21.454 2 22 2.546 22 3.22v4.878a1.22 1.22 0 0 1-2.439 0V6.164L16.765 8.96a1.22 1.22 0 0 1-1.725-1.725l2.796-2.796zM3.22 14.683c.673 0 1.219.546 1.219 1.22v1.933l2.796-2.796a1.22 1.22 0 0 1 1.725 1.725L6.164 19.56h1.934a1.22 1.22 0 0 1 0 2.439H3.22A1.22 1.22 0 0 1 2 20.78v-4.878c0-.673.546-1.22 1.22-1.22m16.341 1.22a1.22 1.22 0 0 1 2.439 0v4.877A1.22 1.22 0 0 1 20.78 22h-4.878a1.22 1.22 0 0 1 0-2.439h1.934l-2.796-2.796a1.22 1.22 0 0 1 1.725-1.725l2.796 2.796z",
    clipRule: "evenodd"
  })));
};
export default SvgExpand;